module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_L_2_L.25a1cde9.jpg";